// Core components
import { Component, OnDestroy, OnInit } from "@angular/core";

// Third party components
import { FieldType } from "@ngx-formly/core";

// Custom components

/**
 * Script start
 */
@Component({
  selector: "formly-qrcode-structure",
  templateUrl: "./qrcode-structure-type.component.html",
  styleUrls: ["./qrcode-structure-type.component.scss"]
})
export class QrcodeStructureTypeComponent extends FieldType implements OnInit, OnDestroy{
  qrcodeData = "";

  constructor(
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    this.qrcodeData = this.field.formControl.value
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    //this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
